(ns web3.components.linkify
  (:require ["linkifyjs/react" :as Linkify]))

(defn linkify [x]
  [:> Linkify {:options {:className "text-blue"
                         :target {:url "_blank"
                                  :rel "noopener"}}} x])